import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { IconBadge } from '@/components/atoms';
import { type ContentItem } from '@/content/site';

/**
 * One answer to one objection, under the promise: an icon, the claim, and the
 * sentence that makes the claim checkable.
 *
 * Icon, claim and supporting detail share one horizontal row. A `ContentItem`
 * keeps the same shape as the site's other icon-and-claim content and shares
 * its icon keys.
 */
export function ImportPromiseProof({ icon, title, text }: ContentItem) {
  return (
    <Stack direction="row" spacing={4} sx={{ alignItems: 'flex-start' }}>
      <IconBadge name={icon} size={40} shape="rounded" tone="tint" />
      <Stack spacing={1} sx={{ minWidth: 0, pt: 0.5 }}>
        <Typography variant="subtitle2" component="h3" sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        {text && (
          <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: '48ch' }}>
            {text}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
